module.exports = __webpack_public_path__ + "static/img/2.ccac2bc2.jpg";